module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('keep-alive', {
    attrs: {
      "include": _vm.include,
      "max": 8
    }
  }, [(_vm.showRouterView) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a49da892"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageContend.vue
// module id = 2424
// module chunks = 68